import Bugsnag from "@bugsnag/js"
import BugsnagPluginVue from "@bugsnag/plugin-vue"
import { storeToRefs } from "pinia"
import { getShouldNotifyBugSnag } from "@/helpers/bugsnag"

import { useUserStore } from "@/stores/user"

const IGNORED_MESSAGES = [
  "Network Error",
  "Failed to fetch",
  "Request aborted",
  "Unable to preload CSS for",
  "error loading dynamically imported module",
  "ResizeObserver loop completed with undelivered notifications",
]

export default {
  install: (app: any) => {
    const { getUserUuid, getUserEmail } = storeToRefs(useUserStore())

    let environment = ""
    if (process.env.NODE_ENV === "development") {
      environment = "development"
    } else if (window.location.hostname === "assessment.assessfirst.com") {
      environment = "production"
    } else {
      environment = "test"
    }

    Bugsnag.start({
      apiKey: "4ef8791a87ebf1f5d4dbeda29d9e81cc",
      plugins: [new BugsnagPluginVue()],
      enabledReleaseStages: ["production", "test"],
      releaseStage: environment,
      autoDetectErrors: true,
      user: {
        id: getUserUuid.value,
        email: getUserEmail.value,
      },
      onError(event) {
        // Filter from message
        const errorMessage =
          typeof event?.originalError === "string"
            ? event.originalError
            : event?.originalError?.message

        const shouldIgnoreFromMessage =
          typeof errorMessage === "string" &&
          IGNORED_MESSAGES.some((message) => errorMessage.includes(message))

        // Filter via the helper (status codes + error codes)
        const shouldIgnoreFromResponse =
          event.originalError?.response &&
          !getShouldNotifyBugSnag(event.originalError.response)

        if (shouldIgnoreFromMessage || shouldIgnoreFromResponse) {
          return false
        }
      },
    })

    app.use(Bugsnag.getPlugin("vue"))
  },
}
